import React from "react";

const Content = ({ className = "", children, ...rest }) => (
  <div className={`modal-content ${className}`} {...rest}>
    {children}
  </div>
);

const CloseButton = ({ className = "", children = "", ...rest }) => (
  <a type="button" className={`bs-close-modal icon-close ${className}`} {...rest}>
    {children}
  </a>
);

const Header = ({ className = "", children, ...rest }) => (
  <div className={`modal-header ${className}`} {...rest}>
    {children}
  </div>
);

const Body = ({ className = "", children, ...rest }) => (
  <div className={`modal-body ${className}`} {...rest}>
    {children}
  </div>
);

const Footer = ({ className = "", children, ...rest }) => (
  <div className={`modal-footer ${className}`} {...rest}>
    {children}
  </div>
);

export default { Content, CloseButton, Header, Body, Footer };
